// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__15nVK","fullWidthContainer":"panel_fullWidthContainer__1g7Bg","opened":"panel_opened__3OONT","closeIcon":"panel_closeIcon__3kyoo","overlay":"panel_overlay__2epqb","header":"panel_header__2QCUk","logo":"panel_logo__2uKFX","title":"panel_title__3sOKh","children":"panel_children__3blR2"};
    if(module.hot) {
      // 1790670283632
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  